




























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import ModalAddProfissionaisEquipeMedica from './ModalAddProfissionaisEquipeMedica.vue'
import _ from 'lodash'

@Component({
  components: {
    ModalAddProfissionaisEquipeMedica,
  },
})
export default class ModalTabelaProfissionaisEquipesMedicas extends Vue {
  readyState = false
  loadTabela = false
  loadProfissionais = false
  loadDelete = ''
  prestadorSearch = ''
  showModalDelete = false
  itemToDelete: string | null = null

  get getRecebimentoStore() { return getModule(RecebimentoStore, this.$store) }

  get getProfissionais() { return this.getRecebimentoStore.profissionaisTable }

  get loadingProfissionais() { return this.loadProfissionais }
  set loadingProfissionais(value: boolean) { this.loadProfissionais = value }

  get loadingDelete() { return this.loadDelete }
  set loadingDelete(value: string) { this.loadDelete = value }

  get loadingTabela() { return this.loadTabela }
  set loadingTabela(value: boolean) { this.loadTabela = value }

  get getGestoresTableHeader() {
    return [
      { text: 'Profissional', class: 'table-headers', align: 'left', value: 'profissionalNome' },
      { text: 'Criado por', class: 'table-headers', align: 'left', value: 'createdByNome' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'createdOn' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModal() {
    return this.getRecebimentoStore.modalTabelaProfissionais
  }

  set showModal(value: boolean) {
    this.getRecebimentoStore.setModalTabelaProfissionais(value)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  debounce = _.debounce(param => this.getRecebimentoStore.getProfissionaisEquipeMedica(param), 700)

  async filterProfissionals() {
    if (this.prestadorSearch.length < 3 && this.prestadorSearch.length > 0) return
    
    this.loadingTabela = true
    await this.debounce(this.prestadorSearch)
    this.loadingTabela = false
  }

  async showModalAddTabelaProfissionais() {
    this.loadingProfissionais = true
    this.getRecebimentoStore.setModalAddProfissional(true)
    this.loadingProfissionais = false
  }

  abrirModalExclusao(id: string) {
    this.itemToDelete = id
    this.showModalDelete = true
  }

  async confirmarDelete() {
    if (!this.itemToDelete) return

    this.loadingDelete = this.itemToDelete
    const request = await this.getRecebimentoStore.deleteTabelaProfissionais(this.itemToDelete)

    if (request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Prestador removido com sucesso!',
        icon: 'check',
        color: '#43A047',
      })
      this.getRecebimentoStore.getProfissionaisEquipeMedica()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loadingDelete = ''
    this.itemToDelete = null
    this.showModalDelete = false
  }

  @Watch('showModal')
  onChangeShowModalPrestadores(value: boolean) {
    if (!value) {
      this.prestadorSearch = ''
    }
  }
}
